import {
  getClubProgrammePreBookingAccess,
  getClubProgrammeStatus,
  getClubProgrammeSelectionMode,
  getClubProgrammeBookingOpensAt,
  getClubProgrammeBookingClosesAt,
  getClubProgrammeClubsCount
} from 'Src/helpers/accessor/accessor';
import { ColumnDefinition } from 'Src/helpers/table/table';
import { FILTER_TYPE } from 'Src/consts/table';

export const CLUB_PROGRAMMES_GRID_COLUMNS: ColumnDefinition[] = [
  {
    text: 'Name',
    field: 'name',
    isSort: true,
    type: FILTER_TYPE.TEXT,
    accessor: ['name']
  },
  {
    text: 'Booking opens',
    field: 'bookingOpensAt',
    isSort: true,
    type: FILTER_TYPE.DATE_INTERVAL,
    accessor: getClubProgrammeBookingOpensAt
  },
  {
    text: 'Booking closes',
    field: 'bookingClosesAt',
    isSort: true,
    type: FILTER_TYPE.DATE_INTERVAL,
    accessor: getClubProgrammeBookingClosesAt
  },
  {
    text: 'Pre-booking',
    field: 'preBookingAccess',
    isSort: false,
    type: FILTER_TYPE.MULTISELECT,
    accessor: getClubProgrammePreBookingAccess
  },
  {
    text: 'Selection mode',
    field: 'selectionMode',
    isSort: true,
    type: FILTER_TYPE.MULTISELECT,
    accessor: getClubProgrammeSelectionMode
  },
  {
    text: 'Status',
    field: 'status',
    isSort: true,
    type: FILTER_TYPE.MULTISELECT,
    accessor: getClubProgrammeStatus
  },
  {
    text: 'Clubs',
    field: 'clubsCount',
    isSort: false,
    type: FILTER_TYPE.NONE,
    accessor: getClubProgrammeClubsCount
  }
];
